import React from "react";
import { useTranslation } from "../../../contexts/TranslationContext";
import { FormVariation } from "../../../types";

interface FormVariationsProps {
  variations: FormVariation[];
}

const FormVariations: React.FC<FormVariationsProps> = ({ variations }) => {
  const { t } = useTranslation();

  return (
    <div className="bg-white shadow rounded-lg">
      <div className="px-4 py-5 sm:p-6">
        <h3 className="text-lg font-medium text-gray-900 mb-4">
          {t("forms.detail.variations.title")}
        </h3>
        <div className="space-y-3">
          {variations.map((variation, index) => (
            <div
              key={variation.id || index}
              className="border border-gray-200 rounded-lg p-3"
            >
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm font-medium text-gray-900">
                    {variation.name}
                  </p>
                  <p className="text-xs text-gray-500 font-mono">
                    {variation.stripe_price_id}
                  </p>
                  <p className="text-xs text-gray-500 font-mono">
                    {variation.pipedrive_variation_id}
                  </p>
                </div>
                <span className="text-sm font-medium text-gray-900">
                  ${(variation.price || 0).toFixed(2)}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FormVariations;

